import { observer } from "mobx-react-lite";
import LanguageStore from "../../store/LanguageStore";
import { formatNumber } from "../../utils/formatNumber";

const ChannelInfo = observer(({image, title, subscriberCount}) => {
    const t = LanguageStore.t;

    return (
        <div className="channel-info">
            <a href={'https://www.youtube.com/@' + title}
                className="channel-info__image-wrapper"
                rel="noreferrer"
                target="_blank"
            >
                <img
                    src={image}
                    alt={title}
                    width="40"
                    height="40"
                    className="channel-info__image"
                />
            </a>

            <div className="channel-info__content">
                <a href={'https://www.youtube.com/@' + title}
                    className="channel-info__title"
                    rel="noreferrer"
                    target="_blank"
                >
                    {title}
                </a>
                <span className="channel-info__subscribers">
                    {formatNumber(subscriberCount)} {t('subscribers')}
                </span>
            </div>
        </div>
    )
});

export default ChannelInfo;